import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Name',
    value: 'couponName',
  },
  {
    label: 'Beneficiary',
    value: 'beneficiaryUserType',
  },
  {
    label: 'Type',
    value: 'couponType',
  },
  {
    label: 'Value',
    value: 'couponValue',
  },
  {
    label: 'Count',
    value: 'numberOfCouponsCreated',
  },
  {
    label: 'Validity date',
    value: 'validityDate',
  },
  // {
  //   label: 'supply chain',
  //   value: 'couponSupplyChain',
  // },
  {
    label: 'Icon',
    value: 'couponIcon',
  },
  {
    label: 'Sponsor',
    value: 'voucherSponsorName',
  },
  // {
  //   label: 'Logo',
  //   value: 'bussinessPermit',
  // },
  {
    action: [''],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
